import { useContext } from "react";
import { createContext } from "react";
import { CartApi } from "./useCartApi";
export const CartContext = createContext<CartApi>({} as CartApi);

export default () => useContext(CartContext);
